import { tracking, sendChameleonAndHeapTrackEvent } from '@bark/bark-core';

export const trackingPayload = {
	seller_profile_id: window?.Bark?.USER?.hashed_seller_profile_id,
	country_id: window?.Bark?.ENV?.ccid,
};

export function bindCsSubTrackingListeners() {
	tracking('credit-subscription-self-service-page', 'page_view', trackingPayload);
	sendChameleonAndHeapTrackEvent('Credit subscription self service page viewed');

	$('#js-view-packages-cta')
		.off('click.view-packages-cta')
		.on('click.view-packages-cta', function () {
			tracking(
				'credit-subscription-self-service-page',
				'view_packages_CTA',
				trackingPayload,
			);
		});

	$('#js-book-a-call-top-page-cta')
		.off('click.book-a-call-top-page-cta')
		.on('click.book-a-call-top-page-cta', function () {
			tracking(
				'credit-subscription-self-service-page',
				'book_a_call_toppage_CTA',
				trackingPayload,
			);
		});

	$('#js-book-a-call-packages-cta')
		.off('click.book-a-call-packages-cta')
		.on('click.book-a-call-packages-cta', function () {
			tracking(
				'credit-subscription-self-service-page',
				'book_a_call_packages_CTA',
				trackingPayload,
			);
		});

	$('.collapse').on('shown.bs.collapse', function () {
		tracking('credit-subscription-self-service-page', 'FAQ_accordian_open', {
			...trackingPayload,
			accordion_name: $(this).attr('id'),
		});
	});

	$('#js-book-a-call-bottom-page-cta')
		.off('click.book-a-call-bottom-page-cta')
		.on('click.book-a-call-bottom-page-cta', function () {
			tracking(
				'credit-subscription-self-service-page',
				'book_a_call_bottompage_CTA',
				trackingPayload,
			);
		});

	if (!$('#packages-available').hasClass('d-none')) {
		tracking('credit-subscription-self-service-page', 'packages_shown', trackingPayload);
	}
	if (!$('#packages-unavailable').hasClass('d-none')) {
		tracking(
			'credit-subscription-self-service-page',
			'packages_not_shown',
			trackingPayload,
		);
	}
}
